import React from 'react';
import * as PropTypes from 'prop-types';
import { Link } from '../../router';

import PageLayout from '../layout/PageLayout';
import R from '../../lib/routes';
import { makeBackendUrl } from '../../lib/backend';
import { searchKbArticlesByTitle } from '../../lib/backend';
import LoadMore from '../widgets/LoadMore';
import i18n from '../../translations/i18n';

import './KBPage.scss';
import { classNamer, capitalizeFirstLetter } from '../../lib/utils';
import { updatePageArticles, resetArticlesPage } from '../../actions/articles';
import { getPageArticles } from '../../selectors/articles';
import KBSearchBar from './KBSearchBar';
import KBArticlesList from './KBArticlesList';

const cn = classNamer('KBPage');

class KBPage extends React.PureComponent {
  PAGE_NAME = R.knowledgeBase;
  _mounted = false;

  state = {
    articles: [],
  };

  componentDidMount() {
    this._mounted = true;
    updatePageArticles(this.PAGE_NAME, { articles: this.props.articles, page: this.props.page });
    const articles = getPageArticles(this.PAGE_NAME, this.props.page);
    this.setState({ articles });
  }

  componentDidUpdate(prevProps) {
    // Update list of articles
    if (prevProps !== this.props) {
      updatePageArticles(this.PAGE_NAME, { articles: this.props.articles, page: this.props.page });
      const articles = getPageArticles(this.PAGE_NAME, this.props.page);
      this.setState({ articles });
    }
  }

  componentWillUnmount() {
    this._mounted = false;
    resetArticlesPage(this.PAGE_NAME);
  }

  onValidTerm = title => searchKbArticlesByTitle(this.props.session, title);

  getRoute = article => R.kbArticleBySlug(article);

  renderCategoryCards() {
    if (!this.props.categories.length) {
      return;
    }
    return (
      <div className={cn('category-cards')}>
        {this.props.categories.map(category => {
          const categoryImage = { src: null, alt: null };
          if (category.category_image) {
            let srcUrl = category.category_image.url;
            if (category.category_image.formats) {
              const { small, medium } = category.category_image.formats;
              if (small) {
                srcUrl = small.url;
              } else if (medium) {
                srcUrl = medium.url;
              }
            }
            categoryImage.src = makeBackendUrl(srcUrl);
            categoryImage.alt = category.category_image.alternativeText;
          }

          return (
            <Link route={R.kbCategoryBySlug(category)} key={category.id}>
              <a className={cn('category-card')}>
                <div className={`${cn('category-card-content')} magnify`}>
                  {category.category_image && (
                    <img
                      className={cn('category-card-img')}
                      src={categoryImage.src}
                      alt={categoryImage.src}
                    />
                  )}
                  {!category.category_number && (
                    <div className="text-danger">{i18n.unserialized}</div>
                  )}
                  <h3 className={cn('category-card-name')}>
                    {capitalizeFirstLetter(category.name)}
                  </h3>
                  <div className={cn('category-card-title')}>{category.title}</div>
                </div>
              </a>
            </Link>
          );
        })}
      </div>
    );
  }

  renderLatestArticles() {
    return (
      <div className={cn('latest-articles')}>
        <h2 className="title">{i18n.latestArticles}</h2>
        <KBArticlesList articles={this.state.articles} showCategory={true} />
      </div>
    );
  }

  render() {
    const { categories, page, totalPages, ...passProps } = this.props;

    return (
      <PageLayout
        title={i18n.kbPageTitle}
        subTitle={i18n.kbPageSEODescription}
        className={cn()}
        {...passProps}
      >
        <div className="row">
          <div className="col-12">
            <KBSearchBar focused={true} onValidTerm={this.onValidTerm} getRoute={this.getRoute} />
            {this.renderCategoryCards()}
            {this.renderLatestArticles()}
            {this.props.articles.length > 0 && (
              <LoadMore totalPages={totalPages} page={page} route={R.knowledgeBase} />
            )}
          </div>
        </div>
      </PageLayout>
    );
  }
}

KBPage.propTypes = {
  session: PropTypes.object,
  categories: PropTypes.array,
  articles: PropTypes.array,
  page: PropTypes.number,
  totalPages: PropTypes.number,
};

export default KBPage;
